//import Libraries
import React from 'react';
import PropTypes from 'prop-types';
import ImageSlider from '../../../../../components/ImageSlider/ImageSlider';

//import Components

//import Style classes
import './HiddenContent.css';

const sliderType = (props)=>{

     let images = props.urls.map((url, idx)=>{
         return <img src={url} alt="" key={idx}/>
     })

    return(
        <div className={"HiddenContent SliderType"}>
            <div className="myCarousel">
                <ImageSlider auto={true}>
                    {images}
                </ImageSlider>
            </div>
            <div className="SliderTypeContent Content">
                <h3>{props.data.name[props.lang]}</h3>
                <p>{props.data.content[props.lang]}</p>
            </div>
        </div>
    )
}

export default sliderType;

sliderType.propTypes = {
    data: PropTypes.object.isRequired
  };



// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/ContentCard/HiddenContent/SliderType.js